import { RepeatingTask, Task } from '@griply/types';
import { useMemo } from 'react';

export type UseRepeatingTasksInput = {
  tasks: Task[];
  undeletedOnly?: boolean;
};

export const useRepeatingTasks = ({
  tasks,
  undeletedOnly,
}: UseRepeatingTasksInput): RepeatingTask[] =>
  useMemo(
    () =>
      tasks.filter(
        ({ schedules, deletedAt }) =>
          !!schedules?.length && (!undeletedOnly || !deletedAt),
      ) as RepeatingTask[],
    [tasks, undeletedOnly],
  );
